import { Card } from "@/components/ui/card";
import { Phone, Mail, MapPin, Clock, MessageCircle } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import LeadForm from "@/components/LeadForm";

export default function Contact() {
  return (
    <div className="bg-white pt-24 sm:pt-28" data-testid="page-contact">
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
        <div className="max-w-3xl">
          <Badge variant="outline" className="border-blue-200 text-blue-900 bg-blue-50/60">Get in touch</Badge>
          <h1 className="font-display mt-4 text-4xl sm:text-5xl font-semibold tracking-tight text-slate-900 leading-[1.1]">
            We're <span className="text-gradient-blue">one call</span> away.
          </h1>
          <p className="mt-5 text-slate-600 leading-relaxed text-lg">
            Walk into our Thane office, talk to us on WhatsApp, or schedule a video meeting.
          </p>
        </div>

        <div className="mt-14 grid lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2 space-y-4">
            <Card className="p-6 border-slate-100 soft-shadow">
              <div className="flex gap-3">
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-blue-50 text-blue-900 shrink-0"><MapPin className="h-5 w-5" /></span>
                <div>
                  <div className="font-semibold text-slate-900">Visit our office</div>
                  <p className="text-sm text-slate-600 mt-1 leading-relaxed">
                    Office No. 103, Sagar Heights,<br />
                    Near Jawahar Library, Station Road,<br />
                    Kalwa West, Thane – 400605
                  </p>
                </div>
              </div>
            </Card>
            <Card className="p-6 border-slate-100 soft-shadow">
              <div className="flex gap-3">
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-blue-50 text-blue-900 shrink-0"><Phone className="h-5 w-5" /></span>
                <div>
                  <div className="font-semibold text-slate-900">Call us</div>
                  <a href="tel:+919821237924" data-testid="contact-phone" className="text-sm text-blue-900 mt-1 block hover:underline">+91 98212 37924</a>
                </div>
              </div>
            </Card>
            <Card className="p-6 border-slate-100 soft-shadow">
              <div className="flex gap-3">
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-emerald-50 text-emerald-700 shrink-0"><MessageCircle className="h-5 w-5" /></span>
                <div>
                  <div className="font-semibold text-slate-900">WhatsApp</div>
                  <a href="https://wa.me/919821237924" target="_blank" rel="noreferrer" data-testid="contact-whatsapp" className="text-sm text-emerald-700 mt-1 block hover:underline">
                    Chat with an advisor
                  </a>
                </div>
              </div>
            </Card>
            <Card className="p-6 border-slate-100 soft-shadow">
              <div className="flex gap-3">
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-blue-50 text-blue-900 shrink-0"><Mail className="h-5 w-5" /></span>
                <div>
                  <div className="font-semibold text-slate-900">Email</div>
                  <a href="mailto:office@samotainsurance.com" data-testid="contact-email" className="text-sm text-blue-900 mt-1 block hover:underline">office@samotainsurance.com</a>
                </div>
              </div>
            </Card>
            <Card className="p-6 border-slate-100 soft-shadow">
              <div className="flex gap-3">
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-blue-50 text-blue-900 shrink-0"><Clock className="h-5 w-5" /></span>
                <div>
                  <div className="font-semibold text-slate-900">Office hours</div>
                  <p className="text-sm text-slate-600 mt-1">Mon – Sat: 10:00 AM – 7:00 PM</p>
                </div>
              </div>
            </Card>
          </div>

          <div className="lg:col-span-3">
            <LeadForm title="Book a consultation" subtitle="Tell us a little about you. A senior advisor will call back within 2 business hours." source="contact_page" testIdPrefix="contact" />
          </div>
        </div>

        <div className="mt-14 rounded-3xl overflow-hidden border border-slate-100 soft-shadow">
          <a
            href="https://goo.gl/maps/9xNv8mvAzXGEMXCn9"
            target="_blank"
            rel="noreferrer"
            data-testid="contact-map-link"
            className="block"
          >
            <iframe
              data-testid="contact-map"
              title="Samota Insurance Office Map"
              src="https://www.google.com/maps?q=Sagar+Heights+Kalwa+West+Thane+400605&output=embed"
              width="100%"
              height="380"
              style={{ border: 0, pointerEvents: "auto" }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </a>
        </div>
      </section>
    </div>
  );
}
